import "./Admin.css";

import { isInIframe, klassi } from "../../utils/utils";
import { useNavigate, useParams } from "react-router-dom";

import AdminCourses from "./components/AdminCourses/AdminCourses";
import AdminExams from "./components/AdminExams/AdminExams";
import AdminGrade from "./components/AdminExams/AdminGrade";
import AdminOrders from "./components/AdminOrders/AdminOrders";
import AdminWorkspaces from "./components/AdminWorkspace/AdminWorkspaces";
import Buckets from "../common/bucket/Buckets";
import Footer from "./components/Footer/Footer";
import Header from "../../components/Header";
import Logs from "./components/Logs/Logs";
import Main from "./components/AdminMain";
import React from "react";
import ThemeIcon from "../../components/custom-icons/ThemeIcon";
import Users from "./components/Users/Users";
import { useLoaUser } from "../app/lessons/lessonHooks";

export type AdminMode =
  | "home"
  | "users"
  | "courses"
  | "exams"
  | "grade"
  | "workspaces"
  | "logs"
  | "buckets"
  | "orders";

const titleMap: Record<AdminMode, string> = {
  home: "",
  users: "Users",
  courses: "Courses",
  exams: "Proficiency Tests",
  grade: "Grade Test", // used?
  workspaces: "Workspaces",
  logs: "Logs",
  buckets: "Buckets",
  orders: "Orders",
};

interface Props {
  mode: AdminMode;
  id?: string;
}

export default function Admin() {
  const { loaUser } = useLoaUser();
  const theModal = React.useRef<HTMLDivElement>(null);
  const { mode, id } = useParams<{ mode: AdminMode; id: string }>(); // Get mode from URL params
  const navigate = useNavigate();

  if (!loaUser?.admin) return null;

  console.log({ mode, id });

  const renderMode = () => {
    switch (mode) {
      case "users":
        return <Users />;
      case "courses":
        return <AdminCourses />;
      case "exams":
        return <AdminExams />;
      case "grade": // Ensure "grade" is handled here
        return <AdminGrade examId={id} />; // Pass the `id` parameter if needed
      case "workspaces":
        return <AdminWorkspaces />;
      case "logs":
        return <Logs />;
      case "buckets":
        return <Buckets root="" permissions={["admin"]} />;
      case "orders":
        return <AdminOrders />;
      default:
        return <Main />;
    }
  };

  const logOut = () => {
    navigate("/logout");
  };

  const isMain = mode === "home";
  const isIframe = isInIframe();

  const headerItemClass = klassi({
    "header-item-clickable": !isMain,
  });

  console.log("Admin", {
    mode,
    id,
    isMain,
    isIframe,
  });

  return (
    <div className="loa-page admin-page">
      <Header>
        <div
          className={headerItemClass}
          onClick={() => navigate("/admins/home")}
        >
          {`${isMain ? "" : "< "}Lóa Admin`}
        </div>
        <div className="header-item">
          <h3>{titleMap[mode || "home"]}</h3>
        </div>
        <div className="flex gap-12">
          {!isIframe && (
            <button className="loa-link-button" onClick={logOut}>
              Log out
            </button>
          )}
          <ThemeIcon />
        </div>
      </Header>
      <div className="admin-content">{renderMode()}</div>
      <Footer />
      <div className="modal-root" ref={theModal}></div>
    </div>
  );
}
